module.exports = __webpack_public_path__ + "media/images/flags/16/Tokelau-51d4e44c10ecdc242d812c168284404f.png";